module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-my-recommendations.svg?9466796033aee1ac1476cd8685c87db5";